// Lectura de PDFs en el navegador con pdf.js (servido desde /vendor/pdfjs, fuera del bundle).
let pdfjsPromise = null;

function loadPdfjs() {
  if (!pdfjsPromise) {
    const base = `${process.env.PUBLIC_URL || ""}/vendor/pdfjs`;
    pdfjsPromise = import(/* webpackIgnore: true */ `${base}/pdf.min.js`)
      .then((mod) => {
        mod.GlobalWorkerOptions.workerSrc = `${base}/pdf.worker.min.js`;
        return mod;
      })
      .catch((e) => {
        pdfjsPromise = null;
        throw e;
      });
  }
  return pdfjsPromise;
}

// Agrupa los textos de cada página en líneas por coordenada Y; las celdas quedan separadas por " | ".
export async function pdfToLines(pdf) {
  const pages = [];
  for (let p = 1; p <= pdf.numPages; p++) {
    const page = await pdf.getPage(p);
    const tc = await page.getTextContent();
    const items = tc.items
      .filter((i) => i.str && i.str.trim() !== "")
      .map((i) => ({ s: i.str, x: i.transform[4], y: i.transform[5], w: i.width }));
    items.sort((a, b) => b.y - a.y || a.x - b.x);
    const lines = [];
    for (const it of items) {
      let ln = lines.find((l) => Math.abs(l.y - it.y) < 3);
      if (!ln) {
        ln = { y: it.y, items: [] };
        lines.push(ln);
      }
      ln.items.push(it);
    }
    lines.sort((a, b) => b.y - a.y);
    pages.push(
      lines.map((l) => {
        l.items.sort((a, b) => a.x - b.x);
        let s = "";
        let prevEnd = null;
        for (const it of l.items) {
          if (prevEnd !== null) s += it.x - prevEnd > 6 ? " | " : it.x - prevEnd > 0.5 ? " " : "";
          s += it.s.trim();
          prevEnd = it.x + it.w;
        }
        return s;
      })
    );
  }
  return pages;
}

export async function readPdf(file) {
  const pdfjs = await loadPdfjs();
  const data = new Uint8Array(await file.arrayBuffer());
  const pdf = await pdfjs.getDocument({ data, verbosity: 0 }).promise;
  try {
    return await pdfToLines(pdf);
  } finally {
    pdf.destroy();
  }
}
